/**
 * @file components/common/ResponsiveModal.tsx
 * @description antd Modal 的響應式包裝：根據斷點自動切換寬度。
 *
 * 預設策略：
 *   isMobile        → 100% （全屏）
 *   isPadPortrait   → 90%
 *   isPadLandscape  → 720px
 *   desktop         → props.width 或 antd 默認 520
 *
 * 使用：與 antd Modal 接口完全一致，只是 width 有了響應式預設值。
 * 若 props.width 已給且為 desktop，仍尊重該值；其它斷點一律以本檔策略為準。
 */
import { Modal, type ModalProps } from 'antd';
import { useResponsive } from '@/hooks/useResponsive';

export interface ResponsiveModalProps extends ModalProps {
  /**
   * 桌面（≥ xl）下的寬度，未提供時用 antd 默認 520。
   * 其它斷點固定使用 100% / 90% / 720。
   */
  width?: ModalProps['width'];
}

export function ResponsiveModal(props: ResponsiveModalProps) {
  const { isMobile, isPadPortrait, isPadLandscape } = useResponsive();
  const { width: desktopWidth, ...rest } = props;

  let resolvedWidth: ModalProps['width'];
  if (isMobile) resolvedWidth = '100%';
  else if (isPadPortrait) resolvedWidth = '90%';
  else if (isPadLandscape) resolvedWidth = 720;
  else resolvedWidth = desktopWidth;

  return <Modal {...rest} width={resolvedWidth} />;
}

export default ResponsiveModal;
